import {
	BifrostBackendApi,
	BifrostBackendNestApi
} from "../gateways/BifrostBackendApi.js";
import appConfig from "../appconfig";
import { store } from "../store/index.js";

const AppUsersQueryProvider = {
	baseUrl: "/app-users/query",
	query({ idpToken, filters, attributes }) {
		const clientTraceIdFromStorage = localStorage.getItem("clientTraceId");
		const useNestAppUsersEndpoint =
			store.getters.featureToggles &&
			store.getters.featureToggles.useNestAppUsersEndpoint;

		const Backend = useNestAppUsersEndpoint
			? BifrostBackendNestApi
			: BifrostBackendApi;

		return Backend.post(
			this.baseUrl,
			{
				tenantId: appConfig.tenantId,
				clientTraceId: clientTraceIdFromStorage ? clientTraceIdFromStorage : "",
				filters,
				attributes
			},
			{
				headers: {
					Authorizationidp: idpToken
				}
			}
		);
	}
};

export default Object.freeze(AppUsersQueryProvider);
